import { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectPrimarySecurity } from '../../selectors/home'
import { selectMarketDepthSecurity } from '../../selectors/common'
import { updateMarketDepthSecurity } from '../../reducer/common.reducer'

/** Keeps market depth in sync with primary security without wiring hooks into App. */
function MarketDepthSync() {
    const dispatch = useDispatch()
    const { primary: primarySecurity } = useSelector(selectPrimarySecurity)
    const marketDepthSecurity = useSelector(selectMarketDepthSecurity)

    useEffect(() => {
        if (primarySecurity && primarySecurity !== marketDepthSecurity) {
            dispatch(updateMarketDepthSecurity(primarySecurity))
        }
    }, [primarySecurity, marketDepthSecurity, dispatch])

    return null
}

export default memo(MarketDepthSync)
